'use strict';

import React from 'react';
import LabelClaro from './LabelClaro';

class InlineSelectClaro extends React.Component{

    constructor(props) {
        super(props);
    }

    render(){
        return (
            <div className="form-group">
                <LabelClaro htmlFor={this.props.idElement} labelText={this.props.labelText} labelTip={this.props.labelTip} className={this.props.labelClassName} />
                <div className={this.props.comboClassName}>
                    <select defaultValue={this.props.value} name="states" id="cboState" className="form-control" onChange={this.props.onChange}>
                        <option key="-1" value="">{this.props.defaultOptionText}</option>
                        { Object.keys(this.props.elements).map((key, index) => { return <option key={index}  value={this.props.elements[key]}>{key}</option>}) }
                    </select>
                    <span className="help-block error-wrapper error-empty">{this.props.error}</span>
                </div>
            </div>
        );
    }
}

InlineSelectClaro.defaultProps = {
    comboClassName: "date-mm col-lg-8 col-md-8 col-sm-12 col-xs-12"
}

export default InlineSelectClaro;